/* eslint-disable react/prop-types */
import React, { useEffect, useState, useCallback } from 'react';
import { SubNav } from '../../ui';
import { boardFilters } from '@/services/athenaBoard';
import TradeOps from './TradeOps';
import MemberOps from './MemberOps';
import ServiceDelivery from './ServiceDelivery';
import StoreOps from './StoreOps';
import styles from './board.less';

/**
 * 经营看板（一级 tab）
 * ------------------------------------------------------------------
 * 取代原来的 h5 iframe 数据中心。二级：
 *   交易经营 / 会员经营 / 服务交付 / 门店运营
 * 口径来自 h5 数据中心（TenantStoreApi/*），门店运营来自商家端
 * B 端看板页面（本轮只搭结构、不做视觉）。
 *
 * 二级导航改用 SubNav（各 tab 之间是平级的，没有第三层）。
 * ⚠️ 2026-09-17：原先「会员经营」还挂了 5 个三级项（SubNav 右侧下拉），
 * 现已取消——那五块改为在页面内「单页平铺 + 右侧锚点」（见 MemberOps）。
 * 因此现在整个看板只有两层，SubNav 不再需要 items / itemValue。
 *
 * 下拉枚举（时间范围 / 订单类型 / 会员类型 / 指标维度）在这里统一拉一次
 * 下发给各子 tab，避免每个区块各自请求。
 */
const BOARD_TABS = [
  { value: 'trade', label: '交易经营', Comp: TradeOps },
  { value: 'member', label: '会员经营', Comp: MemberOps },
  { value: 'service', label: '服务交付', Comp: ServiceDelivery },
  { value: 'store', label: '门店运营', Comp: StoreOps },
];

const BoardTab = (props) => {
  // 注意：这里必须叫 activeTab，与 detail 传下来的 prop 名一致。
  // 之前 detail 改成 activeTab 而这里还解构 activeKey，导致永远是 undefined
  // 而回落成默认项，深链与点击都失效。
  const { tenantId, activeTab, onChange, encryptTenantId, coachUserId } = props;
  const [enums, setEnums] = useState({});

  const load = useCallback(() => {
    boardFilters().then((res) => {
      if (res.code === '00000') setEnums(res.data || {});
    });
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const current =
    BOARD_TABS.find((t) => t.value === (activeTab || 'trade')) || BOARD_TABS[0];
  const Comp = current.Comp;

  return (
    <div>
      <SubNav
        groups={BOARD_TABS.map(({ value, label }) => ({ value, label }))}
        groupValue={activeTab || 'trade'}
        onGroupChange={(v) => {
          onChange && onChange(v);
        }}
      />

      <div className={styles.boardContent}>
        <Comp
          tenantId={tenantId}
          coachUserId={coachUserId}
          enums={enums}
          encryptTenantId={encryptTenantId}
        />
      </div>
    </div>
  );
};

export default BoardTab;
